import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {environment} from "../../../../environments/environment";

@Injectable({
    providedIn: 'root'
})
export class AuthService {

    public endpoint;
    protected http: HttpClient;
    constructor(
        http: HttpClient,
    ) {
        this.http = http;
        this.endpoint = environment.api;
    }

    public getHeaders(extra_headers = {}): HttpHeaders {
        let headers: any = {
            'Content-Type': 'application/json; charset=UTF-8',
        };



        headers = {
            ...headers,
            ... {
                Authorization: 'Bearer ' + this.getJwt()
            }
        };




        return new HttpHeaders(headers);
    }

    public loginWithCode(code) {
        return this.http.post(
            this.endpoint + '/web-audit/auth',
            {code},
            {headers: new HttpHeaders({'Content-Type': 'application/json; charset=UTF-8'})}
        )
    }


    getJwt() {
        return localStorage.getItem('jwt_audit_sgn');
    }

    setJwt(jwt: string) {
        localStorage.setItem('jwt_audit_sgn', jwt);
    }
}
